export default "/_next/static/chunks/fonts/lato-900-italic-059995f5d62565bd0419739de68bc7e2.woff2";